import { Field } from 'formik';
import React from 'react';
import InputDescription from 'src/component/Input/InputDescription';
import InputError from 'src/component/Input/InputError';
import InputLabel from 'src/component/Input/InputLabel';

interface OwnProps {
  label?: string;
  description?: string;
  disabled?: boolean;
  name: string;
  validate?: (value: number | string | boolean | null | undefined) => string | undefined;
}

interface Props extends OwnProps {
}

const InputNumber = (
  {
    name,
    description,
    disabled,
    label,
    validate,
  }: Props,
) => {
  const inputId = `inputText_${name}`;
  return (
    <div className="form-group">
      <InputLabel forInput={inputId} text={label} />
      <Field type="number" name={name} className="form-control" validate={validate} disabled={disabled} />
      <InputError name={name} />
      <InputDescription description={description} />
    </div>
  );
};

export default InputNumber;
